// Copyright (c) 2025 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file wisetime/site/timesheetfield/v1/timesheet_field.proto (package wisetime.site.timesheetfield.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wisetime/site/timesheetfield/v1/timesheet_field.proto.
 */
export const file_wisetime_site_timesheetfield_v1_timesheet_field: GenFile = /*@__PURE__*/
  fileDesc("CjV3aXNldGltZS9zaXRlL3RpbWVzaGVldGZpZWxkL3YxL3RpbWVzaGVldF9maWVsZC5wcm90bxIfd2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MSItChpMaXN0VGltZXNoZWV0RmllbGRzUmVxdWVzdBIPCgdzaXRlX2lkGAEgASgJImgKG0xpc3RUaW1lc2hlZXRGaWVsZHNSZXNwb25zZRJJChB0aW1lc2hlZXRfZmllbGRzGAEgAygLMi8ud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5UaW1lc2hlZXRGaWVsZCLdAgoOVGltZXNoZWV0RmllbGQSCgoCaWQYASABKAkSDwoHc2l0ZV9pZBgCIAEoCRINCgVsYWJlbBgDIAEoCRI4CgRpY29uGAUgASgLMiUud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5JY29uSACIAQESFQoJbGFiZWxfa2V5GAYgASgJQgIYARIVCg1kaXNwbGF5X29yZGVyGAcgASgFEk8KDmxhYmVsX2tleV90eXBlGAggASgOMjcud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5UaW1lc2hlZXRGaWVsZExhYmVsS2V5EkUKBnNvdXJjZRgJIAEoDjI1Lndpc2V0aW1lLnNpdGUudGltZXNoZWV0ZmllbGQudjEuVGltZXNoZWV0RmllbGRTb3VyY2USFgoOdmFsdWVfcmVxdWlyZWQYCiABKAhCBwoFX2ljb24i6QEKG0NyZWF0ZVRpbWVzaGVldEZpZWxkUmVxdWVzdBIPCgdzaXRlX2lkGAEgASgJEg0KBWxhYmVsGAIgASgJEjgKBGljb24YAyABKAsyJS53aXNldGltZS5zaXRlLnRpbWVzaGVldGZpZWxkLnYxLkljb25IAIgBARJPCg5sYWJlbF9rZXlfdHlwZRgEIAEoDjI3Lndpc2V0aW1lLnNpdGUudGltZXNoZWV0ZmllbGQudjEuVGltZXNoZWV0RmllbGRMYWJlbEtleRIWCg52YWx1ZV9yZXF1aXJlZBgFIAEoCEIHCgVfaWNvbiI6ChtEZWxldGVUaW1lc2hlZXRGaWVsZFJlcXVlc3QSDwoHc2l0ZV9pZBgBIAEoCRIKCgJpZBgCIAEoCSLmAwobVXBkYXRlVGltZXNoZWV0RmllbGRSZXF1ZXN0Eg8KB3NpdGVfaWQYASABKAkSCgoCaWQYAiABKAkSYQoGdXBkYXRlGAMgASgLMlEud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5VcGRhdGVUaW1lc2hlZXRGaWVsZFJlcXVlc3QuVGltZXNoZWV0RmllbGRVcGRhdGUaxgIKFFRpbWVzaGVldEZpZWxkVXBkYXRlEhIKBWxhYmVsGAEgASgJSACIAQESOAoEaWNvbhgCIAEoCzIlLndpc2V0aW1lLnNpdGUudGltZXNoZWV0ZmllbGQudjEuSWNvbkgBiAEBElQKDmxhYmVsX2tleV90eXBlGAMgASgOMjcud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5UaW1lc2hlZXRGaWVsZExhYmVsS2V5SAKIAQESHgoRZGVmYXVsdF9vcHRpb25faWQYBCABKAlIA4gBARIbCg52YWx1ZV9yZXF1aXJlZBgFIAEoCEgEiAEBQggKBl9sYWJlbEIHCgVfaWNvbkIRCg9fbGFiZWxfa2V5X3R5cGVCFAoSX2RlZmF1bHRfb3B0aW9uX2lkQhEKD192YWx1ZV9yZXF1aXJlZCJPCiBMaXN0VGltZXNoZWV0RmllbGRPcHRpb25zUmVxdWVzdBIaChJ0aW1lc2hlZXRfZmllbGRfaWQYASABKAkSDwoHc2l0ZV9pZBgCIAEoCSKxAQohTGlzdFRpbWVzaGVldEZpZWxkT3B0aW9uc1Jlc3BvbnNlElYKF3RpbWVzaGVldF9maWVsZF9vcHRpb25zGAEgAygLMjUud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5UaW1lc2hlZXRGaWVsZE9wdGlvbhIeChFkZWZhdWx0X29wdGlvbl9pZBgCIAEoCUgAiAEBQhQKEl9kZWZhdWx0X29wdGlvbl9pZCKpAQohQ3JlYXRlVGltZXNoZWV0RmllbGRPcHRpb25SZXF1ZXN0Eg8KB3NpdGVfaWQYASABKAkSEAoIZmllbGRfaWQYAiABKAkSDQoFbGFiZWwYAyABKAkSGAoLZXh0ZXJuYWxfaWQYBCABKAlIAIgBARIYCgtkZXNjcmlwdGlvbhgFIAEoCUgBiAEBQg4KDF9leHRlcm5hbF9pZEIOCgxfZGVzY3JpcHRpb24iwAIKIVVwZGF0ZVRpbWVzaGVldEZpZWxkT3B0aW9uUmVxdWVzdBIPCgdzaXRlX2lkGAEgASgJEgoKAmlkGAIgASgJEm0KBnVwZGF0ZRgDIAEoCzJdLndpc2V0aW1lLnNpdGUudGltZXNoZWV0ZmllbGQudjEuVXBkYXRlVGltZXNoZWV0RmllbGRPcHRpb25SZXF1ZXN0LlRpbWVzaGVldEZpZWxkT3B0aW9uVXBkYXRlGo4BChpUaW1lc2hlZXRGaWVsZE9wdGlvblVwZGF0ZRISCgVsYWJlbBgBIAEoCUgAiAEBEhgKC2V4dGVybmFsX2lkGAIgASgJSAGIAQESGAoLZGVzY3JpcHRpb24YAyABKAlIAogBAUIICgZfbGFiZWxCDgoMX2V4dGVybmFsX2lkQg4KDF9kZXNjcmlwdGlvbiJACiFEZWxldGVUaW1lc2hlZXRGaWVsZE9wdGlvblJlcXVlc3QSDwoHc2l0ZV9pZBgBIAEoCRIKCgJpZBgCIAEoCSJVCiNEaXNhYmxlVGltZXNoZWV0RmllbGRPcHRpb25zUmVxdWVzdBIPCgdzaXRlX2lkGAEgASgJEhAKCGZpZWxkX2lkGAIgASgJEgsKA2lkcxgDIAMoCSJUCiJFbmFibGVUaW1lc2hlZXRGaWVsZE9wdGlvbnNSZXF1ZXN0Eg8KB3NpdGVfaWQYASABKAkSEAoIZmllbGRfaWQYAiABKAkSCwoDaWRzGAMgAygJIhsKBEljb24SEwoLcGhvc3Bob3JfaWQYASABKAkihAEKJEdlbmVyYXRlVGltZXNoZWV0RmllbGRDb25maWdzUmVxdWVzdBIPCgdzaXRlX2lkGAEgASgJEhMKBnRhZ19pZBgCIAEoCUgAiAEBEisKI3NlbGVjdGVkX3RpbWVzaGVldF9maWVsZF9vcHRpb25faWRzGAMgAygJQgkKB190YWdfaWQidgolR2VuZXJhdGVUaW1lc2hlZXRGaWVsZENvbmZpZ3NSZXNwb25zZRJNCgtjb25maWdfcmVmcxgBIAMoCzI4Lndpc2V0aW1lLnNpdGUudGltZXNoZWV0ZmllbGQudjEuVGltZXNoZWV0RmllbGRDb25maWdSZWYiSgoXVGltZXNoZWV0RmllbGRDb25maWdSZWYSGgoSdGltZXNoZWV0X2ZpZWxkX2lkGAEgASgJEhMKC2NvbmZpZ19oYXNoGAIgASgJIoYBCiRCYXRjaEdldFRpbWVzaGVldEZpZWxkQ29uZmlnc1JlcXVlc3QSDwoHc2l0ZV9pZBgBIAEoCRJNCgtjb25maWdfcmVmcxgCIAMoCzI4Lndpc2V0aW1lLnNpdGUudGltZXNoZWV0ZmllbGQudjEuVGltZXNoZWV0RmllbGRDb25maWdSZWYifwolQmF0Y2hHZXRUaW1lc2hlZXRGaWVsZENvbmZpZ3NSZXNwb25zZRJWChd0aW1lc2hlZXRfZmllbGRfY29uZmlncxgBIAMoCzI1Lndpc2V0aW1lLnNpdGUudGltZXNoZWV0ZmllbGQudjEuVGltZXNoZWV0RmllbGRDb25maWcioQIKFFRpbWVzaGVldEZpZWxkQ29uZmlnEkwKCmNvbmZpZ19yZWYYASABKAsyOC53aXNldGltZS5zaXRlLnRpbWVzaGVldGZpZWxkLnYxLlRpbWVzaGVldEZpZWxkQ29uZmlnUmVmEhkKEWlzX3JlcXVpcmVkX2ZpZWxkGAIgASgIEjAKI3N1Z2dlc3RlZF90aW1lc2hlZXRfZmllbGRfb3B0aW9uX2lkGAMgASgJSACIAQESRgoHb3B0aW9ucxgEIAMoCzI1Lndpc2V0aW1lLnNpdGUudGltZXNoZWV0ZmllbGQudjEuVGltZXNoZWV0RmllbGRPcHRpb25CJgokX3N1Z2dlc3RlZF90aW1lc2hlZXRfZmllbGRfb3B0aW9uX2lkImgKJEJhdGNoR2V0VGltZXNoZWV0RmllbGRPcHRpb25zUmVxdWVzdBIPCgdzaXRlX2lkGAIgASgJEgsKA2lkcxgBIAMoCRIVCghmaWVsZF9pZBgDIAEoCUgAiAEBQgsKCV9maWVsZF9pZCJ/CiVCYXRjaEdldFRpbWVzaGVldEZpZWxkT3B0aW9uc1Jlc3BvbnNlElYKF3RpbWVzaGVldF9maWVsZF9vcHRpb25zGAEgAygLMjUud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5UaW1lc2hlZXRGaWVsZE9wdGlvbiKzAQoUVGltZXNoZWV0RmllbGRPcHRpb24SCgoCaWQYASABKAkSGgoSdGltZXNoZWV0X2ZpZWxkX2lkGAIgASgJEhgKC2V4dGVybmFsX2lkGAMgASgJSACIAQESDQoFbGFiZWwYBCABKAkSGAoLZGVzY3JpcHRpb24YBSABKAlIAYgBARIQCghhcmNoaXZlZBgGIAEoCEIOCgxfZXh0ZXJuYWxfaWRCDgoMX2Rlc2NyaXB0aW9uIjwKKUxpc3RGYXZvdXJpdGVUaW1lc2hlZXRGaWVsZE9wdGlvbnNSZXF1ZXN0Eg8KB3NpdGVfaWQYASABKAkihAEKKkxpc3RGYXZvdXJpdGVUaW1lc2hlZXRGaWVsZE9wdGlvbnNSZXNwb25zZRJWChd0aW1lc2hlZXRfZmllbGRfb3B0aW9ucxgBIAMoCzI1Lndpc2V0aW1lLnNpdGUudGltZXNoZWV0ZmllbGQudjEuVGltZXNoZWV0RmllbGRPcHRpb24iOQomTGlzdFJlY2VudFRpbWVzaGVldEZpZWxkT3B0aW9uc1JlcXVlc3QSDwoHc2l0ZV9pZBgBIAEoCSKBAQonTGlzdFJlY2VudFRpbWVzaGVldEZpZWxkT3B0aW9uc1Jlc3BvbnNlElYKF3RpbWVzaGVldF9maWVsZF9vcHRpb25zGAEgAygLMjUud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5UaW1lc2hlZXRGaWVsZE9wdGlvbiJlCidBZGRGYXZvdXJpdGVUaW1lc2hlZXRGaWVsZE9wdGlvblJlcXVlc3QSDwoHc2l0ZV9pZBgBIAEoCRIXCg9maWVsZF9vcHRpb25faWQYAiABKAkSEAoIcG9zaXRpb24YAyABKA0iVgoqUmVtb3ZlRmF2b3VyaXRlVGltZXNoZWV0RmllbGRPcHRpb25SZXF1ZXN0Eg8KB3NpdGVfaWQYASABKAkSFwoPZmllbGRfb3B0aW9uX2lkGAIgASgJImkKK1Jlb3JkZXJGYXZvdXJpdGVUaW1lc2hlZXRGaWVsZE9wdGlvblJlcXVlc3QSDwoHc2l0ZV9pZBgBIAEoCRIXCg9maWVsZF9vcHRpb25faWQYAiABKAkSEAoIcG9zaXRpb24YAyABKA0qVwoUVGltZXNoZWV0RmllbGRTb3VyY2USJgoiVElNRVNIRUVUX0ZJRUxEX1NPVVJDRV9VTlNQRUNJRklFRBAAEggKBFVTRVIQARINCglDT05ORUNUT1IQAirgAQoWVGltZXNoZWV0RmllbGRMYWJlbEtleRIpCiVUSU1FU0hFRVRfRklFTERfTEFCRUxfS0VZX1VOU1BFQ0lGSUVEEAASJgoiVElNRVNIRUVUX0ZJRUxEX0xBQkVMX0tFWV9BQ1RJVklUWRABEiMKH1RJTUVTSEVFVF9GSUVMRF9MQUJFTF9LRVlfUEhBU0UQAhInCiNUSU1FU0hFRVRfRklFTERfTEFCRUxfS0VZX0JJTExfUkFURRADEiUKIFRJTUVTSEVFVF9GSUVMRF9MQUJFTF9LRVlfQ1VTVE9NEOcHMsEWChVUaW1lc2hlZXRGaWVsZFNlcnZpY2USkAEKE0xpc3RUaW1lc2hlZXRGaWVsZHMSOy53aXNldGltZS5zaXRlLnRpbWVzaGVldGZpZWxkLnYxLkxpc3RUaW1lc2hlZXRGaWVsZHNSZXF1ZXN0Gjwud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5MaXN0VGltZXNoZWV0RmllbGRzUmVzcG9uc2UShQEKFENyZWF0ZVRpbWVzaGVldEZpZWxkEjwud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5DcmVhdGVUaW1lc2hlZXRGaWVsZFJlcXVlc3QaLy53aXNldGltZS5zaXRlLnRpbWVzaGVldGZpZWxkLnYxLlRpbWVzaGVldEZpZWxkEmwKFERlbGV0ZVRpbWVzaGVldEZpZWxkEjwud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5EZWxldGVUaW1lc2hlZXRGaWVsZFJlcXVlc3QaFi5nb29nbGUucHJvdG9idWYuRW1wdHkShQEKFFVwZGF0ZVRpbWVzaGVldEZpZWxkEjwud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5VcGRhdGVUaW1lc2hlZXRGaWVsZFJlcXVlc3QaLy53aXNldGltZS5zaXRlLnRpbWVzaGVldGZpZWxkLnYxLlRpbWVzaGVldEZpZWxkEqIBChlMaXN0VGltZXNoZWV0RmllbGRPcHRpb25zEkEud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5MaXN0VGltZXNoZWV0RmllbGRPcHRpb25zUmVxdWVzdBpCLndpc2V0aW1lLnNpdGUudGltZXNoZWV0ZmllbGQudjEuTGlzdFRpbWVzaGVldEZpZWxkT3B0aW9uc1Jlc3BvbnNlEpcBChpDcmVhdGVUaW1lc2hlZXRGaWVsZE9wdGlvbhJCLndpc2V0aW1lLnNpdGUudGltZXNoZWV0ZmllbGQudjEuQ3JlYXRlVGltZXNoZWV0RmllbGRPcHRpb25SZXF1ZXN0GjUud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5UaW1lc2hlZXRGaWVsZE9wdGlvbhJ4ChpEZWxldGVUaW1lc2hlZXRGaWVsZE9wdGlvbhJCLndpc2V0aW1lLnNpdGUudGltZXNoZWV0ZmllbGQudjEuRGVsZXRlVGltZXNoZWV0RmllbGRPcHRpb25SZXF1ZXN0GhYuZ29vZ2xlLnByb3RvYnVmLkVtcHR5EpcBChpVcGRhdGVUaW1lc2hlZXRGaWVsZE9wdGlvbhJCLndpc2V0aW1lLnNpdGUudGltZXNoZWV0ZmllbGQudjEuVXBkYXRlVGltZXNoZWV0RmllbGRPcHRpb25SZXF1ZXN0GjUud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5UaW1lc2hlZXRGaWVsZE9wdGlvbhJ8ChxEaXNhYmxlVGltZXNoZWV0RmllbGRPcHRpb25zEkQud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5EaXNhYmxlVGltZXNoZWV0RmllbGRPcHRpb25zUmVxdWVzdBoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eRJ6ChtFbmFibGVUaW1lc2hlZXRGaWVsZE9wdGlvbnMSQy53aXNldGltZS5zaXRlLnRpbWVzaGVldGZpZWxkLnYxLkVuYWJsZVRpbWVzaGVldEZpZWxkT3B0aW9uc1JlcXVlc3QaFi5nb29nbGUucHJvdG9idWYuRW1wdHkSrgEKHUdlbmVyYXRlVGltZXNoZWV0RmllbGRDb25maWdzEkUud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5HZW5lcmF0ZVRpbWVzaGVldEZpZWxkQ29uZmlnc1JlcXVlc3QaRi53aXNldGltZS5zaXRlLnRpbWVzaGVldGZpZWxkLnYxLkdlbmVyYXRlVGltZXNoZWV0RmllbGRDb25maWdzUmVzcG9uc2USrgEKHUJhdGNoR2V0VGltZXNoZWV0RmllbGRDb25maWdzEkUud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5CYXRjaEdldFRpbWVzaGVldEZpZWxkQ29uZmlnc1JlcXVlc3QaRi53aXNldGltZS5zaXRlLnRpbWVzaGVldGZpZWxkLnYxLkJhdGNoR2V0VGltZXNoZWV0RmllbGRDb25maWdzUmVzcG9uc2USrgEKHUJhdGNoR2V0VGltZXNoZWV0RmllbGRPcHRpb25zEkUud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5CYXRjaEdldFRpbWVzaGVldEZpZWxkT3B0aW9uc1JlcXVlc3QaRi53aXNldGltZS5zaXRlLnRpbWVzaGVldGZpZWxkLnYxLkJhdGNoR2V0VGltZXNoZWV0RmllbGRPcHRpb25zUmVzcG9uc2USvQEKIkxpc3RGYXZvdXJpdGVUaW1lc2hlZXRGaWVsZE9wdGlvbnMSSi53aXNldGltZS5zaXRlLnRpbWVzaGVldGZpZWxkLnYxLkxpc3RGYXZvdXJpdGVUaW1lc2hlZXRGaWVsZE9wdGlvbnNSZXF1ZXN0Gksud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5MaXN0RmF2b3VyaXRlVGltZXNoZWV0RmllbGRPcHRpb25zUmVzcG9uc2USuQEKIEFkZEZhdm91cml0ZVRpbWVzaGVldEZpZWxkT3B0aW9uEkgud2lzZXRpbWUuc2l0ZS50aW1lc2hlZXRmaWVsZC52MS5BZGRGYXZvdXJpdGVUaW1lc2hlZXRGaWVsZE9wdGlvblJlcXVlc3QaSy53aXNldGltZS5zaXRlLnRpbWVzaGVldGZpZWxkLnYxLkxpc3RGYXZvdXJpdGVUaW1lc2hlZXRGaWVsZE9wdGlvbnNSZXNwb25zZRK/AQojUmVtb3ZlRmF2b3VyaXRlVGltZXNoZWV0RmllbGRPcHRpb24SSy53aXNldGltZS5zaXRlLnRpbWVzaGVldGZpZWxkLnYxLlJlbW92ZUZhdm91cml0ZVRpbWVzaGVldEZpZWxkT3B0aW9uUmVxdWVzdBpLLndpc2V0aW1lLnNpdGUudGltZXNoZWV0ZmllbGQudjEuTGlzdEZhdm91cml0ZVRpbWVzaGVldEZpZWxkT3B0aW9uc1Jlc3BvbnNlEsEBCiRSZW9yZGVyRmF2b3VyaXRlVGltZXNoZWV0RmllbGRPcHRpb24STC53aXNldGltZS5zaXRlLnRpbWVzaGVldGZpZWxkLnYxLlJlb3JkZXJGYXZvdXJpdGVUaW1lc2hlZXRGaWVsZE9wdGlvblJlcXVlc3QaSy53aXNldGltZS5zaXRlLnRpbWVzaGVldGZpZWxkLnYxLkxpc3RGYXZvdXJpdGVUaW1lc2hlZXRGaWVsZE9wdGlvbnNSZXNwb25zZRK0AQofTGlzdFJlY2VudFRpbWVzaGVldEZpZWxkT3B0aW9ucxJHLndpc2V0aW1lLnNpdGUudGltZXNoZWV0ZmllbGQudjEuTGlzdFJlY2VudFRpbWVzaGVldEZpZWxkT3B0aW9uc1JlcXVlc3QaSC53aXNldGltZS5zaXRlLnRpbWVzaGVldGZpZWxkLnYxLkxpc3RSZWNlbnRUaW1lc2hlZXRGaWVsZE9wdGlvbnNSZXNwb25zZUJHCidjb20ud2lzZXRpbWUuYXBpLnNpdGUudGltZXNoZWV0ZmllbGQudjFCGlRpbWVzaGVldEZpZWxkU2VydmljZVByb3RvUAFiBnByb3RvMw", [file_google_protobuf_empty]);

/**
 * @generated from message wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest
 */
export type ListTimesheetFieldsRequest = Message<"wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest.
 * Use `create(ListTimesheetFieldsRequestSchema)` to create a new message.
 */
export const ListTimesheetFieldsRequestSchema: GenMessage<ListTimesheetFieldsRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 0);

/**
 * @generated from message wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse
 */
export type ListTimesheetFieldsResponse = Message<"wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse"> & {
  /**
   * @generated from field: repeated wisetime.site.timesheetfield.v1.TimesheetField timesheet_fields = 1;
   */
  timesheetFields: TimesheetField[];
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse.
 * Use `create(ListTimesheetFieldsResponseSchema)` to create a new message.
 */
export const ListTimesheetFieldsResponseSchema: GenMessage<ListTimesheetFieldsResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 1);

/**
 * @generated from message wisetime.site.timesheetfield.v1.TimesheetField
 */
export type TimesheetField = Message<"wisetime.site.timesheetfield.v1.TimesheetField"> & {
  /**
   * Primary key/unique identifier (a timesheet_field_id).
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string site_id = 2;
   */
  siteId: string;

  /**
   * Display label - for well-known fields, serves as fallback; for custom fields, the actual display name.
   *
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * Icon for the option.
   *
   * @generated from field: optional wisetime.site.timesheetfield.v1.Icon icon = 5;
   */
  icon?: Icon;

  /**
   * An optional consistent label key, such as ACTIVITY, PHASE, BILL_RATE etc (not shown in UI).
   * this is useful for rules context.
   *
   * @generated from field: string label_key = 6 [deprecated = true];
   * @deprecated
   */
  labelKey: string;

  /**
   * Display order for UI rendering.
   *
   * @generated from field: int32 display_order = 7;
   */
  displayOrder: number;

  /**
   * Predefined common label keys, with CUSTOM for user-defined ones.
   * Frontend uses this enum to lookup localized strings for well-known fields.
   *
   * @generated from field: wisetime.site.timesheetfield.v1.TimesheetFieldLabelKey label_key_type = 8;
   */
  labelKeyType: TimesheetFieldLabelKey;

  /**
   * @generated from field: wisetime.site.timesheetfield.v1.TimesheetFieldSource source = 9;
   */
  source: TimesheetFieldSource;

  /**
   * If true - user has to select value for this field when posting time.
   *
   * @generated from field: bool value_required = 10;
   */
  valueRequired: boolean;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.TimesheetField.
 * Use `create(TimesheetFieldSchema)` to create a new message.
 */
export const TimesheetFieldSchema: GenMessage<TimesheetField> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 2);

/**
 * @generated from message wisetime.site.timesheetfield.v1.CreateTimesheetFieldRequest
 */
export type CreateTimesheetFieldRequest = Message<"wisetime.site.timesheetfield.v1.CreateTimesheetFieldRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: optional wisetime.site.timesheetfield.v1.Icon icon = 3;
   */
  icon?: Icon;

  /**
   * @generated from field: wisetime.site.timesheetfield.v1.TimesheetFieldLabelKey label_key_type = 4;
   */
  labelKeyType: TimesheetFieldLabelKey;

  /**
   * @generated from field: bool value_required = 5;
   */
  valueRequired: boolean;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.CreateTimesheetFieldRequest.
 * Use `create(CreateTimesheetFieldRequestSchema)` to create a new message.
 */
export const CreateTimesheetFieldRequestSchema: GenMessage<CreateTimesheetFieldRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 3);

/**
 * @generated from message wisetime.site.timesheetfield.v1.DeleteTimesheetFieldRequest
 */
export type DeleteTimesheetFieldRequest = Message<"wisetime.site.timesheetfield.v1.DeleteTimesheetFieldRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.DeleteTimesheetFieldRequest.
 * Use `create(DeleteTimesheetFieldRequestSchema)` to create a new message.
 */
export const DeleteTimesheetFieldRequestSchema: GenMessage<DeleteTimesheetFieldRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 4);

/**
 * @generated from message wisetime.site.timesheetfield.v1.UpdateTimesheetFieldRequest
 */
export type UpdateTimesheetFieldRequest = Message<"wisetime.site.timesheetfield.v1.UpdateTimesheetFieldRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: wisetime.site.timesheetfield.v1.UpdateTimesheetFieldRequest.TimesheetFieldUpdate update = 3;
   */
  update?: UpdateTimesheetFieldRequest_TimesheetFieldUpdate;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.UpdateTimesheetFieldRequest.
 * Use `create(UpdateTimesheetFieldRequestSchema)` to create a new message.
 */
export const UpdateTimesheetFieldRequestSchema: GenMessage<UpdateTimesheetFieldRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 5);

/**
 * @generated from message wisetime.site.timesheetfield.v1.UpdateTimesheetFieldRequest.TimesheetFieldUpdate
 */
export type UpdateTimesheetFieldRequest_TimesheetFieldUpdate = Message<"wisetime.site.timesheetfield.v1.UpdateTimesheetFieldRequest.TimesheetFieldUpdate"> & {
  /**
   * @generated from field: optional string label = 1;
   */
  label?: string;

  /**
   * @generated from field: optional wisetime.site.timesheetfield.v1.Icon icon = 2;
   */
  icon?: Icon;

  /**
   * @generated from field: optional wisetime.site.timesheetfield.v1.TimesheetFieldLabelKey label_key_type = 3;
   */
  labelKeyType?: TimesheetFieldLabelKey;

  /**
   * @generated from field: optional string default_option_id = 4;
   */
  defaultOptionId?: string;

  /**
   * @generated from field: optional bool value_required = 5;
   */
  valueRequired?: boolean;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.UpdateTimesheetFieldRequest.TimesheetFieldUpdate.
 * Use `create(UpdateTimesheetFieldRequest_TimesheetFieldUpdateSchema)` to create a new message.
 */
export const UpdateTimesheetFieldRequest_TimesheetFieldUpdateSchema: GenMessage<UpdateTimesheetFieldRequest_TimesheetFieldUpdate> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 5, 0);

/**
 * @generated from message wisetime.site.timesheetfield.v1.ListTimesheetFieldOptionsRequest
 */
export type ListTimesheetFieldOptionsRequest = Message<"wisetime.site.timesheetfield.v1.ListTimesheetFieldOptionsRequest"> & {
  /**
   * @generated from field: string timesheet_field_id = 1;
   */
  timesheetFieldId: string;

  /**
   * @generated from field: string site_id = 2;
   */
  siteId: string;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.ListTimesheetFieldOptionsRequest.
 * Use `create(ListTimesheetFieldOptionsRequestSchema)` to create a new message.
 */
export const ListTimesheetFieldOptionsRequestSchema: GenMessage<ListTimesheetFieldOptionsRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 6);

/**
 * @generated from message wisetime.site.timesheetfield.v1.ListTimesheetFieldOptionsResponse
 */
export type ListTimesheetFieldOptionsResponse = Message<"wisetime.site.timesheetfield.v1.ListTimesheetFieldOptionsResponse"> & {
  /**
   * @generated from field: repeated wisetime.site.timesheetfield.v1.TimesheetFieldOption timesheet_field_options = 1;
   */
  timesheetFieldOptions: TimesheetFieldOption[];

  /**
   * @generated from field: optional string default_option_id = 2;
   */
  defaultOptionId?: string;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.ListTimesheetFieldOptionsResponse.
 * Use `create(ListTimesheetFieldOptionsResponseSchema)` to create a new message.
 */
export const ListTimesheetFieldOptionsResponseSchema: GenMessage<ListTimesheetFieldOptionsResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 7);

/**
 * @generated from message wisetime.site.timesheetfield.v1.CreateTimesheetFieldOptionRequest
 */
export type CreateTimesheetFieldOptionRequest = Message<"wisetime.site.timesheetfield.v1.CreateTimesheetFieldOptionRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string field_id = 2;
   */
  fieldId: string;

  /**
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * @generated from field: optional string external_id = 4;
   */
  externalId?: string;

  /**
   * @generated from field: optional string description = 5;
   */
  description?: string;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.CreateTimesheetFieldOptionRequest.
 * Use `create(CreateTimesheetFieldOptionRequestSchema)` to create a new message.
 */
export const CreateTimesheetFieldOptionRequestSchema: GenMessage<CreateTimesheetFieldOptionRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 8);

/**
 * @generated from message wisetime.site.timesheetfield.v1.UpdateTimesheetFieldOptionRequest
 */
export type UpdateTimesheetFieldOptionRequest = Message<"wisetime.site.timesheetfield.v1.UpdateTimesheetFieldOptionRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: wisetime.site.timesheetfield.v1.UpdateTimesheetFieldOptionRequest.TimesheetFieldOptionUpdate update = 3;
   */
  update?: UpdateTimesheetFieldOptionRequest_TimesheetFieldOptionUpdate;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.UpdateTimesheetFieldOptionRequest.
 * Use `create(UpdateTimesheetFieldOptionRequestSchema)` to create a new message.
 */
export const UpdateTimesheetFieldOptionRequestSchema: GenMessage<UpdateTimesheetFieldOptionRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 9);

/**
 * @generated from message wisetime.site.timesheetfield.v1.UpdateTimesheetFieldOptionRequest.TimesheetFieldOptionUpdate
 */
export type UpdateTimesheetFieldOptionRequest_TimesheetFieldOptionUpdate = Message<"wisetime.site.timesheetfield.v1.UpdateTimesheetFieldOptionRequest.TimesheetFieldOptionUpdate"> & {
  /**
   * @generated from field: optional string label = 1;
   */
  label?: string;

  /**
   * Only editable for USER-created timesheet fields.
   *
   * @generated from field: optional string external_id = 2;
   */
  externalId?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.UpdateTimesheetFieldOptionRequest.TimesheetFieldOptionUpdate.
 * Use `create(UpdateTimesheetFieldOptionRequest_TimesheetFieldOptionUpdateSchema)` to create a new message.
 */
export const UpdateTimesheetFieldOptionRequest_TimesheetFieldOptionUpdateSchema: GenMessage<UpdateTimesheetFieldOptionRequest_TimesheetFieldOptionUpdate> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 9, 0);

/**
 * @generated from message wisetime.site.timesheetfield.v1.DeleteTimesheetFieldOptionRequest
 */
export type DeleteTimesheetFieldOptionRequest = Message<"wisetime.site.timesheetfield.v1.DeleteTimesheetFieldOptionRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.DeleteTimesheetFieldOptionRequest.
 * Use `create(DeleteTimesheetFieldOptionRequestSchema)` to create a new message.
 */
export const DeleteTimesheetFieldOptionRequestSchema: GenMessage<DeleteTimesheetFieldOptionRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 10);

/**
 * @generated from message wisetime.site.timesheetfield.v1.DisableTimesheetFieldOptionsRequest
 */
export type DisableTimesheetFieldOptionsRequest = Message<"wisetime.site.timesheetfield.v1.DisableTimesheetFieldOptionsRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string field_id = 2;
   */
  fieldId: string;

  /**
   * @generated from field: repeated string ids = 3;
   */
  ids: string[];
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.DisableTimesheetFieldOptionsRequest.
 * Use `create(DisableTimesheetFieldOptionsRequestSchema)` to create a new message.
 */
export const DisableTimesheetFieldOptionsRequestSchema: GenMessage<DisableTimesheetFieldOptionsRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 11);

/**
 * @generated from message wisetime.site.timesheetfield.v1.EnableTimesheetFieldOptionsRequest
 */
export type EnableTimesheetFieldOptionsRequest = Message<"wisetime.site.timesheetfield.v1.EnableTimesheetFieldOptionsRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string field_id = 2;
   */
  fieldId: string;

  /**
   * @generated from field: repeated string ids = 3;
   */
  ids: string[];
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.EnableTimesheetFieldOptionsRequest.
 * Use `create(EnableTimesheetFieldOptionsRequestSchema)` to create a new message.
 */
export const EnableTimesheetFieldOptionsRequestSchema: GenMessage<EnableTimesheetFieldOptionsRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 12);

/**
 * Message allows future expansion of icon properties and different icon sources.
 *
 * @generated from message wisetime.site.timesheetfield.v1.Icon
 */
export type Icon = Message<"wisetime.site.timesheetfield.v1.Icon"> & {
  /**
   * Phosphor icon ID (https://phosphoricons.com).
   * For example, L100 (Legal) may use `scales`, Case Management as `folder-open` etc.
   *
   * @generated from field: string phosphor_id = 1;
   */
  phosphorId: string;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.Icon.
 * Use `create(IconSchema)` to create a new message.
 */
export const IconSchema: GenMessage<Icon> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 13);

/**
 * @generated from message wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest
 */
export type GenerateTimesheetFieldConfigsRequest = Message<"wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: optional string tag_id = 2;
   */
  tagId?: string;

  /**
   * @generated from field: repeated string selected_timesheet_field_option_ids = 3;
   */
  selectedTimesheetFieldOptionIds: string[];
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.
 * Use `create(GenerateTimesheetFieldConfigsRequestSchema)` to create a new message.
 */
export const GenerateTimesheetFieldConfigsRequestSchema: GenMessage<GenerateTimesheetFieldConfigsRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 14);

/**
 * @generated from message wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse
 */
export type GenerateTimesheetFieldConfigsResponse = Message<"wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse"> & {
  /**
   * @generated from field: repeated wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef config_refs = 1;
   */
  configRefs: TimesheetFieldConfigRef[];
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse.
 * Use `create(GenerateTimesheetFieldConfigsResponseSchema)` to create a new message.
 */
export const GenerateTimesheetFieldConfigsResponseSchema: GenMessage<GenerateTimesheetFieldConfigsResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 15);

/**
 * @generated from message wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef
 */
export type TimesheetFieldConfigRef = Message<"wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef"> & {
  /**
   * @generated from field: string timesheet_field_id = 1;
   */
  timesheetFieldId: string;

  /**
   * Unique hash for timesheet field configuration, used to retrieve options later.
   *
   * @generated from field: string config_hash = 2;
   */
  configHash: string;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.
 * Use `create(TimesheetFieldConfigRefSchema)` to create a new message.
 */
export const TimesheetFieldConfigRefSchema: GenMessage<TimesheetFieldConfigRef> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 16);

/**
 * @generated from message wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest
 */
export type BatchGetTimesheetFieldConfigsRequest = Message<"wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: repeated wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef config_refs = 2;
   */
  configRefs: TimesheetFieldConfigRef[];
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest.
 * Use `create(BatchGetTimesheetFieldConfigsRequestSchema)` to create a new message.
 */
export const BatchGetTimesheetFieldConfigsRequestSchema: GenMessage<BatchGetTimesheetFieldConfigsRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 17);

/**
 * @generated from message wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse
 */
export type BatchGetTimesheetFieldConfigsResponse = Message<"wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse"> & {
  /**
   * @generated from field: repeated wisetime.site.timesheetfield.v1.TimesheetFieldConfig timesheet_field_configs = 1;
   */
  timesheetFieldConfigs: TimesheetFieldConfig[];
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse.
 * Use `create(BatchGetTimesheetFieldConfigsResponseSchema)` to create a new message.
 */
export const BatchGetTimesheetFieldConfigsResponseSchema: GenMessage<BatchGetTimesheetFieldConfigsResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 18);

/**
 * @generated from message wisetime.site.timesheetfield.v1.TimesheetFieldConfig
 */
export type TimesheetFieldConfig = Message<"wisetime.site.timesheetfield.v1.TimesheetFieldConfig"> & {
  /**
   * @generated from field: wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef config_ref = 1;
   */
  configRef?: TimesheetFieldConfigRef;

  /**
   * Is option selection mandatory?
   *
   * @generated from field: bool is_required_field = 2;
   */
  isRequiredField: boolean;

  /**
   * Suggested initial/selected option for the field.
   *
   * @generated from field: optional string suggested_timesheet_field_option_id = 3;
   */
  suggestedTimesheetFieldOptionId?: string;

  /**
   * Available options for this configuration.
   *
   * @generated from field: repeated wisetime.site.timesheetfield.v1.TimesheetFieldOption options = 4;
   */
  options: TimesheetFieldOption[];
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.TimesheetFieldConfig.
 * Use `create(TimesheetFieldConfigSchema)` to create a new message.
 */
export const TimesheetFieldConfigSchema: GenMessage<TimesheetFieldConfig> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 19);

/**
 * @generated from message wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest
 */
export type BatchGetTimesheetFieldOptionsRequest = Message<"wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest"> & {
  /**
   * @generated from field: string site_id = 2;
   */
  siteId: string;

  /**
   * start one_of filter
   *
   * @generated from field: repeated string ids = 1;
   */
  ids: string[];

  /**
   * end one_of filter
   *
   * @generated from field: optional string field_id = 3;
   */
  fieldId?: string;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.
 * Use `create(BatchGetTimesheetFieldOptionsRequestSchema)` to create a new message.
 */
export const BatchGetTimesheetFieldOptionsRequestSchema: GenMessage<BatchGetTimesheetFieldOptionsRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 20);

/**
 * @generated from message wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse
 */
export type BatchGetTimesheetFieldOptionsResponse = Message<"wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse"> & {
  /**
   * @generated from field: repeated wisetime.site.timesheetfield.v1.TimesheetFieldOption timesheet_field_options = 1;
   */
  timesheetFieldOptions: TimesheetFieldOption[];
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse.
 * Use `create(BatchGetTimesheetFieldOptionsResponseSchema)` to create a new message.
 */
export const BatchGetTimesheetFieldOptionsResponseSchema: GenMessage<BatchGetTimesheetFieldOptionsResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 21);

/**
 * @generated from message wisetime.site.timesheetfield.v1.TimesheetFieldOption
 */
export type TimesheetFieldOption = Message<"wisetime.site.timesheetfield.v1.TimesheetFieldOption"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string timesheet_field_id = 2;
   */
  timesheetFieldId: string;

  /**
   * External ID for this value, such as a business/display code (e.g., "BILL-001", "PHASE-DISC").
   *
   * UNIQUENESS CONSTRAINT: Must be unique within the TimesheetField's option_set when provided.
   * - Uniqueness is case-sensitive: "LEGAL-001" and "legal-001" are considered different
   * - Null/empty values are excluded from uniqueness validation (multiple nulls allowed)
   * - External systems may rely on these codes for integration, so duplicates can cause data integrity issues
   *
   * Example violation:
   * TimesheetField "Activity Type" with values:
   * - value_id: "123", external_id: "LEGAL-001", value_label: "Legal Research"
   * - value_id: "456", external_id: "LEGAL-001", value_label: "Legal Analysis"  // INVALID: Duplicate external_id
   *
   * @generated from field: optional string external_id = 3;
   */
  externalId?: string;

  /**
   * Human-readable display name.
   *
   * @generated from field: string label = 4;
   */
  label: string;

  /**
   * Longer explanation/tooltip text.
   *
   * @generated from field: optional string description = 5;
   */
  description?: string;

  /**
   * @generated from field: bool archived = 6;
   */
  archived: boolean;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.TimesheetFieldOption.
 * Use `create(TimesheetFieldOptionSchema)` to create a new message.
 */
export const TimesheetFieldOptionSchema: GenMessage<TimesheetFieldOption> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 22);

/**
 * @generated from message wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest
 */
export type ListFavouriteTimesheetFieldOptionsRequest = Message<"wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest.
 * Use `create(ListFavouriteTimesheetFieldOptionsRequestSchema)` to create a new message.
 */
export const ListFavouriteTimesheetFieldOptionsRequestSchema: GenMessage<ListFavouriteTimesheetFieldOptionsRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 23);

/**
 * @generated from message wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse
 */
export type ListFavouriteTimesheetFieldOptionsResponse = Message<"wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse"> & {
  /**
   * @generated from field: repeated wisetime.site.timesheetfield.v1.TimesheetFieldOption timesheet_field_options = 1;
   */
  timesheetFieldOptions: TimesheetFieldOption[];
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse.
 * Use `create(ListFavouriteTimesheetFieldOptionsResponseSchema)` to create a new message.
 */
export const ListFavouriteTimesheetFieldOptionsResponseSchema: GenMessage<ListFavouriteTimesheetFieldOptionsResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 24);

/**
 * @generated from message wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest
 */
export type ListRecentTimesheetFieldOptionsRequest = Message<"wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest.
 * Use `create(ListRecentTimesheetFieldOptionsRequestSchema)` to create a new message.
 */
export const ListRecentTimesheetFieldOptionsRequestSchema: GenMessage<ListRecentTimesheetFieldOptionsRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 25);

/**
 * @generated from message wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse
 */
export type ListRecentTimesheetFieldOptionsResponse = Message<"wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse"> & {
  /**
   * @generated from field: repeated wisetime.site.timesheetfield.v1.TimesheetFieldOption timesheet_field_options = 1;
   */
  timesheetFieldOptions: TimesheetFieldOption[];
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse.
 * Use `create(ListRecentTimesheetFieldOptionsResponseSchema)` to create a new message.
 */
export const ListRecentTimesheetFieldOptionsResponseSchema: GenMessage<ListRecentTimesheetFieldOptionsResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 26);

/**
 * @generated from message wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest
 */
export type AddFavouriteTimesheetFieldOptionRequest = Message<"wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string field_option_id = 2;
   */
  fieldOptionId: string;

  /**
   * 0-based index
   *
   * @generated from field: uint32 position = 3;
   */
  position: number;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest.
 * Use `create(AddFavouriteTimesheetFieldOptionRequestSchema)` to create a new message.
 */
export const AddFavouriteTimesheetFieldOptionRequestSchema: GenMessage<AddFavouriteTimesheetFieldOptionRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 27);

/**
 * @generated from message wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest
 */
export type RemoveFavouriteTimesheetFieldOptionRequest = Message<"wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string field_option_id = 2;
   */
  fieldOptionId: string;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest.
 * Use `create(RemoveFavouriteTimesheetFieldOptionRequestSchema)` to create a new message.
 */
export const RemoveFavouriteTimesheetFieldOptionRequestSchema: GenMessage<RemoveFavouriteTimesheetFieldOptionRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 28);

/**
 * @generated from message wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest
 */
export type ReorderFavouriteTimesheetFieldOptionRequest = Message<"wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string field_option_id = 2;
   */
  fieldOptionId: string;

  /**
   * 0-based index
   *
   * @generated from field: uint32 position = 3;
   */
  position: number;
};

/**
 * Describes the message wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest.
 * Use `create(ReorderFavouriteTimesheetFieldOptionRequestSchema)` to create a new message.
 */
export const ReorderFavouriteTimesheetFieldOptionRequestSchema: GenMessage<ReorderFavouriteTimesheetFieldOptionRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 29);

/**
 * @generated from enum wisetime.site.timesheetfield.v1.TimesheetFieldSource
 */
export enum TimesheetFieldSource {
  /**
   * @generated from enum value: TIMESHEET_FIELD_SOURCE_UNSPECIFIED = 0;
   */
  TIMESHEET_FIELD_SOURCE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: USER = 1;
   */
  USER = 1,

  /**
   * @generated from enum value: CONNECTOR = 2;
   */
  CONNECTOR = 2,
}

/**
 * Describes the enum wisetime.site.timesheetfield.v1.TimesheetFieldSource.
 */
export const TimesheetFieldSourceSchema: GenEnum<TimesheetFieldSource> = /*@__PURE__*/
  enumDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 0);

/**
 * @generated from enum wisetime.site.timesheetfield.v1.TimesheetFieldLabelKey
 */
export enum TimesheetFieldLabelKey {
  /**
   * @generated from enum value: TIMESHEET_FIELD_LABEL_KEY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TIMESHEET_FIELD_LABEL_KEY_ACTIVITY = 1;
   */
  ACTIVITY = 1,

  /**
   * @generated from enum value: TIMESHEET_FIELD_LABEL_KEY_PHASE = 2;
   */
  PHASE = 2,

  /**
   * @generated from enum value: TIMESHEET_FIELD_LABEL_KEY_BILL_RATE = 3;
   */
  BILL_RATE = 3,

  /**
   * Use custom_label_key field.
   *
   * @generated from enum value: TIMESHEET_FIELD_LABEL_KEY_CUSTOM = 999;
   */
  CUSTOM = 999,
}

/**
 * Describes the enum wisetime.site.timesheetfield.v1.TimesheetFieldLabelKey.
 */
export const TimesheetFieldLabelKeySchema: GenEnum<TimesheetFieldLabelKey> = /*@__PURE__*/
  enumDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 1);

/**
 * @generated from service wisetime.site.timesheetfield.v1.TimesheetFieldService
 */
export const TimesheetFieldService: GenService<{
  /**
   * Retrieves all timesheet fields for a given site.
   * The frontend can fetch and cache these fields on startup.
   *
   * @generated from rpc wisetime.site.timesheetfield.v1.TimesheetFieldService.ListTimesheetFields
   */
  listTimesheetFields: {
    methodKind: "unary";
    input: typeof ListTimesheetFieldsRequestSchema;
    output: typeof ListTimesheetFieldsResponseSchema;
  },
  /**
   * Create a new timesheet field.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:  Missing site_id or label.
   * - PERMISSION_DENIED: User doesn't have permission to perform this action.
   *
   * @generated from rpc wisetime.site.timesheetfield.v1.TimesheetFieldService.CreateTimesheetField
   */
  createTimesheetField: {
    methodKind: "unary";
    input: typeof CreateTimesheetFieldRequestSchema;
    output: typeof TimesheetFieldSchema;
  },
  /**
   * Delete a timesheet field.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:  Missing id or site_id.
   * - NOT_FOUND:         Field not found.
   * - PERMISSION_DENIED: User doesn't have permission to perform this action.
   *
   * @generated from rpc wisetime.site.timesheetfield.v1.TimesheetFieldService.DeleteTimesheetField
   */
  deleteTimesheetField: {
    methodKind: "unary";
    input: typeof DeleteTimesheetFieldRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Update a timesheet field.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:  Missing site_id or id.
   * - NOT_FOUND:         Field not found.
   * - PERMISSION_DENIED: User doesn't have permission to perform this action.
   *
   * @generated from rpc wisetime.site.timesheetfield.v1.TimesheetFieldService.UpdateTimesheetField
   */
  updateTimesheetField: {
    methodKind: "unary";
    input: typeof UpdateTimesheetFieldRequestSchema;
    output: typeof TimesheetFieldSchema;
  },
  /**
   * @generated from rpc wisetime.site.timesheetfield.v1.TimesheetFieldService.ListTimesheetFieldOptions
   */
  listTimesheetFieldOptions: {
    methodKind: "unary";
    input: typeof ListTimesheetFieldOptionsRequestSchema;
    output: typeof ListTimesheetFieldOptionsResponseSchema;
  },
  /**
   * Create a new timesheet field option.
   *
   * Only applicable for USER-created timesheet fields.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    Missing site_id, field_id or label.
   * - NOT_FOUND:           Parent field not found.
   * - FAILED_PRECONDITION: Duplicate label or external ID.
   * - PERMISSION_DENIED:   User doesn't have permission to perform this action.
   *
   * @generated from rpc wisetime.site.timesheetfield.v1.TimesheetFieldService.CreateTimesheetFieldOption
   */
  createTimesheetFieldOption: {
    methodKind: "unary";
    input: typeof CreateTimesheetFieldOptionRequestSchema;
    output: typeof TimesheetFieldOptionSchema;
  },
  /**
   * Delete timesheet field option.
   *
   * Only applicable for USER-created timesheet fields.
   *
   * Possible failures:
   * - PRECONDITION_FAILED:  Option has associated timesheet entries and cannot be deleted - user has to archive instead.
   * - INVALID_ARGUMENT:     Missing site_id or id.
   * - NOT_FOUND:            Option not found.
   * - PERMISSION_DENIED:    User doesn't have permission to perform this action.
   *
   * @generated from rpc wisetime.site.timesheetfield.v1.TimesheetFieldService.DeleteTimesheetFieldOption
   */
  deleteTimesheetFieldOption: {
    methodKind: "unary";
    input: typeof DeleteTimesheetFieldOptionRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Update a timesheet field option.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:    Missing site_id or id.
   * - NOT_FOUND:           Option not found or parent field not found.
   * - FAILED_PRECONDITION: Duplicate label or external ID.
   * - PERMISSION_DENIED:   User doesn't have permission to perform this action.
   *
   * @generated from rpc wisetime.site.timesheetfield.v1.TimesheetFieldService.UpdateTimesheetFieldOption
   */
  updateTimesheetFieldOption: {
    methodKind: "unary";
    input: typeof UpdateTimesheetFieldOptionRequestSchema;
    output: typeof TimesheetFieldOptionSchema;
  },
  /**
   * Disable (aka archive) timesheet field options.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:  Missing site_id, field_id, or empty ids list.
   * - NOT_FOUND:         Field not found.
   * - PERMISSION_DENIED: User doesn't have permission to perform this action.
   *
   * @generated from rpc wisetime.site.timesheetfield.v1.TimesheetFieldService.DisableTimesheetFieldOptions
   */
  disableTimesheetFieldOptions: {
    methodKind: "unary";
    input: typeof DisableTimesheetFieldOptionsRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Enable timesheet field options.
   * see DisableTimesheetFieldOptions for more.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:  Missing site_id, field_id, or empty ids list.
   * - NOT_FOUND:         Field not found.
   * - PERMISSION_DENIED: User doesn't have permission to perform this action.
   *
   * @generated from rpc wisetime.site.timesheetfield.v1.TimesheetFieldService.EnableTimesheetFieldOptions
   */
  enableTimesheetFieldOptions: {
    methodKind: "unary";
    input: typeof EnableTimesheetFieldOptionsRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Generate configurations for timesheet fields based on selected tag and options.
   * The frontend should call this when a user applies a tag to a timesheet entry and when the user changes
   * the selected option for a timesheet field dependency.
   *
   * @generated from rpc wisetime.site.timesheetfield.v1.TimesheetFieldService.GenerateTimesheetFieldConfigs
   */
  generateTimesheetFieldConfigs: {
    methodKind: "unary";
    input: typeof GenerateTimesheetFieldConfigsRequestSchema;
    output: typeof GenerateTimesheetFieldConfigsResponseSchema;
  },
  /**
   * Fetch available configurations for timesheet fields.
   * The frontend may cache a config by its hash key (up to max of 24-hours) to avoid repeated calls.
   *
   * @generated from rpc wisetime.site.timesheetfield.v1.TimesheetFieldService.BatchGetTimesheetFieldConfigs
   */
  batchGetTimesheetFieldConfigs: {
    methodKind: "unary";
    input: typeof BatchGetTimesheetFieldConfigsRequestSchema;
    output: typeof BatchGetTimesheetFieldConfigsResponseSchema;
  },
  /**
   * Fetch timesheet field options by IDs.
   *
   * @generated from rpc wisetime.site.timesheetfield.v1.TimesheetFieldService.BatchGetTimesheetFieldOptions
   */
  batchGetTimesheetFieldOptions: {
    methodKind: "unary";
    input: typeof BatchGetTimesheetFieldOptionsRequestSchema;
    output: typeof BatchGetTimesheetFieldOptionsResponseSchema;
  },
  /**
   * @generated from rpc wisetime.site.timesheetfield.v1.TimesheetFieldService.ListFavouriteTimesheetFieldOptions
   */
  listFavouriteTimesheetFieldOptions: {
    methodKind: "unary";
    input: typeof ListFavouriteTimesheetFieldOptionsRequestSchema;
    output: typeof ListFavouriteTimesheetFieldOptionsResponseSchema;
  },
  /**
   * @generated from rpc wisetime.site.timesheetfield.v1.TimesheetFieldService.AddFavouriteTimesheetFieldOption
   */
  addFavouriteTimesheetFieldOption: {
    methodKind: "unary";
    input: typeof AddFavouriteTimesheetFieldOptionRequestSchema;
    output: typeof ListFavouriteTimesheetFieldOptionsResponseSchema;
  },
  /**
   * @generated from rpc wisetime.site.timesheetfield.v1.TimesheetFieldService.RemoveFavouriteTimesheetFieldOption
   */
  removeFavouriteTimesheetFieldOption: {
    methodKind: "unary";
    input: typeof RemoveFavouriteTimesheetFieldOptionRequestSchema;
    output: typeof ListFavouriteTimesheetFieldOptionsResponseSchema;
  },
  /**
   * @generated from rpc wisetime.site.timesheetfield.v1.TimesheetFieldService.ReorderFavouriteTimesheetFieldOption
   */
  reorderFavouriteTimesheetFieldOption: {
    methodKind: "unary";
    input: typeof ReorderFavouriteTimesheetFieldOptionRequestSchema;
    output: typeof ListFavouriteTimesheetFieldOptionsResponseSchema;
  },
  /**
   * @generated from rpc wisetime.site.timesheetfield.v1.TimesheetFieldService.ListRecentTimesheetFieldOptions
   */
  listRecentTimesheetFieldOptions: {
    methodKind: "unary";
    input: typeof ListRecentTimesheetFieldOptionsRequestSchema;
    output: typeof ListRecentTimesheetFieldOptionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_wisetime_site_timesheetfield_v1_timesheet_field, 0);

